export const currentUser = {
	init: () => {
		currentUser.token = localStorage.getItem('token') || null;
		currentUser.token = localStorage.getItem('token_expire_time') || null;
		currentUser.refresh_token = localStorage.getItem('refresh_token') || null;
		JSON.parse(localStorage.getItem('user')) || {};
	},
	isLogin: () => {
		return currentUser.getToken();
	},

	// Setter
	setToken: (token) => {
		currentUser.token = token;
		localStorage.setItem('token', token);
	},
	setTokenExpireTime: (expire_time) => {
		currentUser.token_expire_time = expire_time;
		localStorage.setItem('token_expire_time', expire_time);
	},
	setRefrshToken: (token) => {
		currentUser.refresh_token = token;
		localStorage.setItem('refresh_token', token);
	},
	setUser: (user) => {
		currentUser.user = user;
		localStorage.setItem('user', JSON.stringify(user));
	},

	// Getter
	getToken: () => {
		return currentUser.token;
	},
	getTokenExpireTime: () => {
		return currentUser.token_expire_time;
	},
	getRefreshToken: () => {
		return currentUser.refresh_token;
	},
	getUser: function () {
		return JSON.parse(localStorage.getItem('user')) || {};
	},

	// Reset
	resetUser: () => {
		localStorage.removeItem('token');
		localStorage.removeItem('refresh_token');
		localStorage.removeItem('user');
		currentUser.init();
	}
};

currentUser.init();
